import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class TendersService {
    static async getAllTenders(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.TENDERS; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch tenders.');
            return [];
        }
    }

    // Create
    static async addNewTender(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.TENDERS; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Tender added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new tender.');
        }
    }

    // Get by ID
    static async getTenderById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TENDERS}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch tender by ID');
        }
    }

    // Update
    static async updateTenderById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TENDERS}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Tender updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update tender.');
        }
    }

    // Delete 
    static async deleteTender(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TENDERS}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete tender.');
            }
        } catch (error) {
            console.error('Error deleting tender:', error);
            throw error;
        }
    }

    // Delete multiple 
    static async deleteManyTenders(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.TENDERS}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
